import React from 'react';
import { aboutInfo } from '../mock';
import { Target, Eye, Award, Users } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <section className="bg-gradient-to-br from-[#001F3F] to-[#003366] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{aboutInfo.title}</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            {aboutInfo.mainText}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              {aboutInfo.description}
            </p>

            <div className="grid md:grid-cols-2 gap-8 mt-12">
              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                  <Target size={32} className="text-[#001F3F]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Misyonumuz</h3>
                  <p className="text-gray-600">
                    Goo More ürünleri ile müşterilerimizin hayat kalitesini artırmak.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                  <Eye size={32} className="text-[#001F3F]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Vizyonumuz</h3>
                  <p className="text-gray-600">
                    Dünya çapında tercih edilen, güvenilir bir marka olmak.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                  <Award size={32} className="text-[#001F3F]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Kalitemiz</h3>
                  <p className="text-gray-600">
                    Uluslararası standartlara uygun, sertifikalı ürünler sunuyoruz.
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="p-3 bg-[#001F3F]/10 rounded-lg">
                  <Users size={32} className="text-[#001F3F]" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-[#001F3F] mb-2">Ekibimiz</h3>
                  <p className="text-gray-600">
                    Her an yanınızdayız.Doğru bilgilendirme ile destek sağlıyoruz.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-br from-[#001F3F] to-[#003366]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">15M+</div>
              <div className="text-white/80">Ürün Kullanıcısı</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">%98</div>
              <div className="text-white/80">Müşteri Memnuniyeti</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">100+</div>
              <div className="text-white/80">Ülkeye İhracat</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-white mb-2">23</div>
              <div className="text-white/80">Ürün Sayısı</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;